import React, { Fragment } from "react";
import { DKButton, DKTooltipWrapper } from "deskera-ui-library";
import ic_visibility_2 from "../../assets/icons/white/ic_visibility_2.svg";
import ic_invisibility from "../../assets/icons/white/ic_invisibility.svg";
import { isMobileWebView } from "../../utility/ViewportSizeUtils";

function MaskUnmaskButton(props) {

    const getWebViewButton = () => {
        return (
            <DKTooltipWrapper content={"Mask/Unmask Text"} tooltipClassName="warning-tooltip-prop" className="z-index-3">
                <DKButton
                    className={`bg-app text-white circle ${props.className}`}
                    style={{
                        height: "31px",
                        ...props.style
                    }}
                    icon={props.mask ? ic_invisibility : ic_visibility_2}
                    onClick={() => {
                        props.onClick();
                    }}
                />
            </DKTooltipWrapper>
        );
    }

    const getMobileViewButton = () => {
        return (
            <DKButton
                className={`bg-app text-white circle ${props.className}`}
                style={{
                    height: "31px",
                    ...props.style
                }}
                icon={props.mask ? ic_invisibility : ic_visibility_2}
                onClick={() => {
                    props.onClick();
                }}
            />
        );
    }

    return (
        <Fragment>
            {!isMobileWebView() && getWebViewButton()}
            {isMobileWebView() && getMobileViewButton()}
        </Fragment>
    );
}

export default MaskUnmaskButton;

